import { AbiItem } from 'web3-utils'
import UniversalProfile from '@lukso/universalprofile-contracts/artifacts/UniversalProfile.json'
import UniversalProfileInit from '@lukso/universalprofile-contracts/artifacts/UniversalProfileInit.json'

import {
  ContractEventType,
  ContractEventTypeArray,
} from '@/shared/models/ContractEvent'

export const upEventsABI: AbiItem[] = [
  ...(UniversalProfile.abi as AbiItem[]).filter(
    ({ type, name }) =>
      type === 'event' &&
      name &&
      ContractEventTypeArray.includes(name as ContractEventType)
  ),
  ...(UniversalProfileInit.abi as AbiItem[]).filter(
    ({ type, name }) =>
      type === 'event' && name === ContractEventType.INITIALIZED
  ),
]
